import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button"
import { buttonVariants } from "@/components/ui/button";
interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  description: string;
  icon?: React.ReactNode;
  buttonConfirmText?: string;
  buttonCancelText?: string;
  buttonConfirmVariant?: string;
  buttonCancelVariant?: string;
  onConfirm?: (isConfirmed: boolean) => void
  loading?: boolean;
}

export function ConfirmationDialog({
  open,
  title,
  description,
  icon,
  buttonConfirmText = 'Yes',
  buttonConfirmVariant = 'secondary',
  buttonCancelText = 'Cancel',
  buttonCancelVariant = 'outline-destructive',
  onConfirm,
  loading = false,
}: ConfirmationDialogProps) {

  const [show, setShow] = useState(open)
  const handleConfirm = () => {
    onConfirm && onConfirm(true);
  }

  const handleCancel = () => {
    onConfirm && onConfirm(false);
  }

  useEffect(() => {
    setShow(open)
  }, [open])

  return (
    <AlertDialog open={show}>
      <AlertDialogContent>
        <AlertDialogHeader >
          <div>
            <AlertDialogTitle className="flex flex-row items-center gap-4 ">
              {icon}
              {title}
            </AlertDialogTitle>
            <AlertDialogDescription className="mt-4 mb-4 text-foreground">
              {description}
            </AlertDialogDescription>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild onClick={handleCancel}>
            <Button variant={buttonCancelVariant as keyof typeof buttonVariants}>{buttonCancelText}</Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild onClick={handleConfirm}>
            <Button variant={buttonConfirmVariant as keyof typeof buttonVariants} loading={loading}>{buttonConfirmText}</Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}